import React from "react";
import { Link } from "react-router-dom";

export default function BlogLayout({ children }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Sticky nav */}
      <nav className="sticky top-0 z-40 bg-background/95 backdrop-blur border-b border-border/60">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link to="/" className="font-serif-display text-lg font-medium leading-none">
              ProofMark
            </Link>
            <span className="text-border text-sm">·</span>
            <Link
              to="/blog"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Blog
            </Link>
          </div>
          <div className="flex items-center gap-3">
            <Link
              to="/tools"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors hidden sm:block"
            >
              Free tools
            </Link>
            <Link
              to="/app"
              className="text-sm bg-brand text-brand-foreground px-3 py-1.5 rounded-md hover:opacity-90 transition-opacity"
            >
              Open app
            </Link>
          </div>
        </div>
      </nav>

      {/* Page content */}
      <main className="max-w-3xl mx-auto px-6 py-12">{children}</main>

      {/* Footer */}
      <footer className="border-t border-border/60 mt-16">
        <div className="max-w-3xl mx-auto px-6 py-10 grid sm:grid-cols-3 gap-8">
          <div>
            <p className="tracked-caps mb-3">Blog</p>
            <ul className="space-y-1.5">
              <li>
                <Link
                  to="/blog"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  All posts
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="tracked-caps mb-3">Learn</p>
            <ul className="space-y-1.5">
              {[
                { to: "/tools", label: "Free tools" },
                { to: "/glossary/ai-knowledge-governance", label: "AI knowledge governance" },
                { to: "/glossary/ai-knowledge-artifact", label: "Knowledge artifacts" },
                { to: "/glossary/contributor-class", label: "Contributor classes" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="tracked-caps mb-3">Product</p>
            <ul className="space-y-1.5">
              {[
                { to: "/", label: "Overview" },
                { to: "/app", label: "Open app" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
